/** @format */

import { api, getServiceConfig } from 'utility';
import AuthApi from 'components/Auth/Api';
import { getReportAccountNumberUrl, getReportBillsUrl } from 'URLs';
export async function getBusinessApi() {
  const configBaseUrl = await getServiceConfig();
  const baseUrlDefault = process.env?.REACT_APP_API_JAVA
    ? `${process.env.REACT_APP_API_JAVA}${process.env.REACT_APP_BASE_URL}`
    : `${process.env.REACT_APP_BASE_URL}`;

  // Set dynamic base URL for axios
  api.axios.defaults.baseURL = configBaseUrl?.result?.baseUrl || baseUrlDefault;
  return AuthApi.fetchBusiness();
}
export function reportAccountNumber() {
  return api.get(getReportAccountNumberUrl()).then((res) => res.data);
}
export function reportTransaction(data, params) {
  return api.post(getReportBillsUrl(), data, { params }).then((res) => res.data);
}
